import { ProductFamilyService } from './productFamily.service';
import { DimensionModel } from '@core/model/dimension.model';
import { DimensionItemModel } from '@core/model/dimensionItem.model';
import { UserModel } from '@core/model/user.model';
import { ItemInformationModel } from '@core/model/itemInformation.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MasterClientModel } from '@core/model/masterClient.model';
import { Injectable } from "@angular/core";

@Injectable()
export class AddToShoppingCartService {
    private unsubscribe$ = new Subject<void>();
    public dimensionItemModel: DimensionItemModel = new DimensionItemModel();
    private userModel: UserModel = new UserModel();
    public dimensionColor: DimensionModel[] = [];
    public dimensionEstilo: DimensionModel[] = [];
    public dimensionTamano: DimensionModel[] = [];
    public dimensionConfig: DimensionModel[] = [];
    public itemInfoModel: ItemInformationModel = new ItemInformationModel();
    public dimensions: DimensionModel[] = [];
    public colorSelected = '';
    public estiloSelected = '';
    public tamanoSelected = '';
    public configSelected = '';
    enableCartButton = false;
    public watchAll = 'VER TODOS';
    public ready: boolean = false;
    private masterClientModel: MasterClientModel = new MasterClientModel();
    constructor(private productFamilyService: ProductFamilyService) {
    }
    
    getProductDetail() {
        this.dimensionItemModel.ItemId = this.itemInfoModel.ItemId;
        this.dimensionItemModel.UserId = this.userModel.UserId;
        this.dimensionItemModel.Color = this.colorSelected;
        this.dimensionItemModel.Style = this.estiloSelected;
        this.dimensionItemModel.Size = this.tamanoSelected;
        this.dimensionItemModel.configId = this.configSelected;
        this.dimensionItemModel.Currency = this.masterClientModel.Currency;
        this.dimensionItemModel.CustAccount = this.masterClientModel.CustAccount;
        this.productFamilyService.getDisplayItemDetail(this.dimensionItemModel)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                response => {
                    this.itemInfoModel = response;
                });
    }
    
    getProductDimensions() {
        this.productFamilyService.getInventDimensionsByItems(this.itemInfoModel)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(response => {
            this.ready = true;
            if (response != null) {
                this.dimensions = response;
                this.dimensionColor = response;
                let hash = {};
                this.dimensionColor = this.dimensionColor.filter(function (current) {
                    let exists = (!hash[current.Color] || false) && current.Color !== '';
                    hash[current.Color] = true;
                    return exists;
                });
                this.dimensionEstilo = response;
                let hash2 = {};
                this.dimensionEstilo = this.dimensionEstilo.filter(function (current) {
                    let exists = (!hash2[current.Estilo] || false) && current.Estilo !== '';
                    hash2[current.Estilo] = true;
                    return exists;
                });
                this.dimensionTamano = response;
                let hash3 = {};
                this.dimensionTamano = this.dimensionTamano.filter(function (current) {
                    let exists = (!hash3[current.Tamano] || false) && current.Tamano !== '';
                    hash3[current.Tamano] = true;
                    return exists;
                });
                this.dimensionConfig = response;
                let hash4 = {};
                this.dimensionConfig = this.dimensionConfig.filter(function (current) {
                    let exists = (!hash4[current.Config] || false) && current.Config !== '';
                    hash4[current.Config] = true;
                    return exists;
                });
                if (this.colorSelected !== '') {
                    this.setDimensionsValue(this.colorSelected, 'color');
                }
                if (this.estiloSelected !== '') {
                    this.setDimensionsValue(this.estiloSelected, 'estilo');
                }
                if (this.tamanoSelected !== '') {
                    this.setDimensionsValue(this.tamanoSelected, 'tamano');
                }
            }
        });
            
        let dataReturn = {
            dimensionColor: this.getDimensionColor,
            dimensionConfig: this.dimensionConfig,
            dimensionEstilo: this.dimensionEstilo,
            dimensionTamano: this.dimensionTamano
        }
        return dataReturn;
    }

    setDimensionsValue(value, type) {
        if (value === 'all') {
            this.dimensionColor = [];
            this.dimensionEstilo = [];
            this.dimensionTamano = [];
            this.dimensionConfig = [];
            this.colorSelected = '';
            this.estiloSelected = '';
            this.tamanoSelected = '';
            this.configSelected = '';
            this.enableCartButton = false;
            this.dimensions.forEach(item => {
                this.dimensionColor.push(item);
                this.dimensionEstilo.push(item);
                this.dimensionTamano.push(item);
                this.dimensionConfig.push(item);
            });

            let hash = {};
            this.dimensionColor = this.dimensionColor.filter(function (current) {
                let exists = (!hash[current.Color] || false) && current.Color !== '';
                hash[current.Color] = true;
                return exists;
            });
            let hash2 = {};
            this.dimensionEstilo = this.dimensionEstilo.filter(function (current) {
                let exists = (!hash2[current.Estilo] || false) && current.Estilo !== '';
                hash2[current.Estilo] = true;
                return exists;
            });
            let hash3 = {};
            this.dimensionTamano = this.dimensionTamano.filter(function (current) {
                let exists = (!hash3[current.Tamano] || false) && current.Tamano !== '';
                hash3[current.Tamano] = true;
                return exists;
            });
            let hash4 = {};
            this.dimensionConfig = this.dimensionConfig.filter(function (current) {
                let exists = (!hash4[current.Config] || false) && current.Config !== '';
                hash4[current.Config] = true;
                return exists;
            });

        } else {
            switch (type) {
                case 'color':
                    this.filterTamano(value, type);
                    this.filterEstilo(value, type);
                    this.filterConfig(value, type);
                    break;
                case 'estilo':
                    this.filterColor(value, type);
                    this.filterTamano(value, type);
                    this.filterConfig(value, type);
                    break;
                case 'tamano':
                    this.filterColor(value, type);
                    this.filterEstilo(value, type);
                    this.filterConfig(value, type);
                    break;
                case 'config':
                    this.filterColor(value, type);
                    this.filterEstilo(value, type);
                    this.filterTamano(value, type);
                    break;
            }
        }
    }

    filterColor(value, type) {
        this.dimensionColor = [];
        this.dimensions.forEach(item => {
            switch (type) {
                case 'color':
                    if (item.Color === value) {
                        this.dimensionColor.push(item);
                    }
                    break;
                case 'estilo':
                    if (item.Estilo === value) {
                        this.dimensionColor.push(item);
                    }
                    break;
                case 'tamano':
                    if (item.Tamano === value) {
                        this.dimensionColor.push(item);
                    }
                    break;
                case 'config':
                    if (item.Config === value) {
                        this.dimensionColor.push(item);
                    }
                    break;
            }
        });
        let hash = {};
        this.dimensionColor = this.dimensionColor.filter(function (current) {
            let exists = (!hash[current.Color] || false) && current.Color !== '';
            hash[current.Color] = true;
            return exists;
        });
    }

    filterEstilo(value, type) {
        this.dimensionEstilo = [];
        this.dimensions.forEach(item => {
            switch (type) {
                case 'color':
                    if (item.Color === value) {
                        this.dimensionEstilo.push(item);
                    }
                    break;
                case 'estilo':
                    if (item.Estilo === value) {
                        this.dimensionEstilo.push(item);
                    }
                    break;
                case 'tamano':
                    if (item.Tamano === value) {
                        this.dimensionEstilo.push(item);
                    }
                    break;
                case 'config':
                    if (item.Config === value) {
                        this.dimensionEstilo.push(item);
                    }
                    break;
            }
        });
        let hash2 = {};
        this.dimensionEstilo = this.dimensionEstilo.filter(function (current) {
            let exists = (!hash2[current.Estilo] || false) && current.Estilo !== '';
            hash2[current.Estilo] = true;
            return exists;
        });
    }

    filterTamano(value, type) {
        this.dimensionTamano = [];
        this.dimensions.forEach(item => {
            switch (type) {
                case 'color':
                    if (item.Color === value) {
                        this.dimensionTamano.push(item);
                    }
                    break;
                case 'estilo':
                    if (item.Estilo === value) {
                        this.dimensionTamano.push(item);
                    }
                    break;
                case 'tamano':
                    if (item.Tamano === value) {
                        this.dimensionTamano.push(item);
                    }
                    break;
                case 'config':
                    if (item.Config === value) {
                        this.dimensionTamano.push(item);
                    }
                    break;
            }
        });
        let hash3 = {};
        this.dimensionTamano = this.dimensionTamano.filter(function (current) {
            let exists = (!hash3[current.Tamano] || false) && current.Tamano !== '';
            hash3[current.Tamano] = true;
            return exists;
        });
    }

    filterConfig(value, type) {
        this.dimensionConfig = [];
        this.dimensions.forEach(item => {
            switch (type) {
                case 'color':
                    if (item.Color === value) {
                        this.dimensionConfig.push(item);
                    }
                    break;
                case 'estilo':
                    if (item.Estilo === value) {
                        this.dimensionConfig.push(item);
                    }
                    break;
                case 'tamano':
                    if (item.Tamano === value) {
                        this.dimensionConfig.push(item);
                    }
                    break;
                case 'config':
                    if (item.Config === value) {
                        this.dimensionConfig.push(item);
                    }
                    break;
            }
        });
        let hash4 = {};
        this.dimensionConfig = this.dimensionConfig.filter(function (current) {
            let exists = (!hash4[current.Config] || false) && current.Config !== '';
            hash4[current.Config] = true;
            return exists;
        });
    }

    setMasterClient(masterClient) {
        this.masterClientModel = masterClient;
    }
    setUser(user) {
        this.userModel = user;
    }
    setItemIfo(itemInfo) {
        this.itemInfoModel = itemInfo;
    }
    getDimensionColor() {
        return this.dimensionColor;
    }

    getDimensionTamano() {
        return this.dimensionTamano;
    }

    getDimensionEstilo() {
        return this.dimensionEstilo;
    }

    getDimensionConfig() {
        return this.dimensionConfig;
    }
}